module.exports = __webpack_public_path__ + "teqbahn-assets/media/Jointhecallimage.86d58250.png";